import {
    afterNextRender,
    Component,
    ElementRef,
    HostListener,
    inject,
    signal,
    Signal,
    ViewEncapsulation,
    ChangeDetectionStrategy
} from '@angular/core';
import { Router } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';
import { select, Store } from '@ngxs/store';
import { Language } from '../../models/language.interface';
import { SetCurrentLanguage } from '../../states/language/language.actions';
import { LanguageState } from '../../states/language/language.state';

@Component({
    selector: 'shig-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [TranslatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {
    private readonly elementRef = inject(ElementRef);
    private readonly router = inject(Router);
    private readonly store = inject(Store);

    protected readonly languages: Signal<Language[]> = select(LanguageState.languages);
    protected readonly currentLanguage: Signal<Language> = select(LanguageState.currentLanguage);

    protected readonly showLanguageSelection = signal<boolean>(false);

    constructor() {
        afterNextRender(() => {
            const height = this.elementRef.nativeElement.offsetHeight;
            document.documentElement.style.setProperty('--header-height', `${height}px`);
        });
    }

    @HostListener('document:click', ['$event'])
    protected clickout(event: Event): void {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.showLanguageSelection.set(false);
        }
    }

    protected openLanguageSelection(): void {
        this.showLanguageSelection.update(value => !value);
    }

    protected closeLanguageSelection(): void {
        this.showLanguageSelection.set(false);
    }

    protected onFocusOut(event: FocusEvent): void {
        if (!this.elementRef.nativeElement.contains(event.relatedTarget as Node)) {
            this.showLanguageSelection.set(false);
        }
    }

    protected gotoStartPage(): void {
        this.router.navigate(['/']);
    }

    protected changeLanguage(code: string): void {
        this.store.dispatch(new SetCurrentLanguage(code));
    }
}
